import styled from "styled-components";

export const Container = styled.div`
    background-color: white;
    padding: 24px;
`;

export const HeaderComponent = styled.div`
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 18px;
    color: #2d3748;
    font-family: "Roboto", "Roboto-Medium" !important;
`;

export const BannerItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    margin-bottom: 8px;
    background-color: #fafbfc;
    font-family: "Roboto";
    font-size: 14px;
    color: #2d3748;
`;

export const BannerLabel = styled.span`
    font-weight: 500;
`;

export const SwapButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #595959;
    padding: 4px 8px;
    border-radius: 4px;
    &:hover {
        background-color: #e4e7ed;
    }
    &:disabled {
        cursor: not-allowed;
        opacity: 0.3;
    }
`;

export const ActionButtonComponent = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
`;
